import React from 'react';
import AdminSubscriptionRecord from "../../components/admin/components/AdminSubscriptionRecord";

const SubscriptionRecords = () => {
    return <AdminSubscriptionRecord />;
};

export default SubscriptionRecords;
